var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionPremium1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_42474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.05882 12.1194H4.17647C4.75882 12.1194 5.23529 11.643 5.23529 11.0606V8.94297C5.23529 8.36061 4.75882 7.88414 4.17647 7.88414H2.05882C1.47647 7.88414 1 8.36061 1 8.94297V11.0606C1 11.643 1.47647 12.1194 2.05882 12.1194ZM2.05882 17.4136H4.17647C4.75882 17.4136 5.23529 16.9371 5.23529 16.3547V14.2371C5.23529 13.6547 4.75882 13.1783 4.17647 13.1783H2.05882C1.47647 13.1783 1 13.6547 1 14.2371V16.3547C1 16.9371 1.47647 17.4136 2.05882 17.4136ZM2.05882 6.82532H4.17647C4.75882 6.82532 5.23529 6.34885 5.23529 5.7665V3.64885C5.23529 3.0665 4.75882 2.59003 4.17647 2.59003H2.05882C1.47647 2.59003 1 3.0665 1 3.64885V5.7665C1 6.34885 1.47647 6.82532 2.05882 6.82532ZM7.35294 12.1194H17.9412C18.5235 12.1194 19 11.643 19 11.0606V8.94297C19 8.36061 18.5235 7.88414 17.9412 7.88414H7.35294C6.77059 7.88414 6.29412 8.36061 6.29412 8.94297V11.0606C6.29412 11.643 6.77059 12.1194 7.35294 12.1194ZM7.35294 17.4136H17.9412C18.5235 17.4136 19 16.9371 19 16.3547V14.2371C19 13.6547 18.5235 13.1783 17.9412 13.1783H7.35294C6.77059 13.1783 6.29412 13.6547 6.29412 14.2371V16.3547C6.29412 16.9371 6.77059 17.4136 7.35294 17.4136ZM6.29412 3.64885V5.7665C6.29412 6.34885 6.77059 6.82532 7.35294 6.82532H17.9412C18.5235 6.82532 19 6.34885 19 5.7665V3.64885C19 3.0665 18.5235 2.59003 17.9412 2.59003H7.35294C6.77059 2.59003 6.29412 3.0665 6.29412 3.64885Z",
    fill: "#E2E8EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_42474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionPremium1);
export default __webpack_public_path__ + "static/media/optionPremium1.d921da0abb49c4ea9d53ef4cc055ffa7.svg";
export { ForwardRef as ReactComponent };